import { ALLOWED_FILE_SIZE, ALLOWED_FILE_TYPES } from 'consts/consts';
import onErrorImg from 'icons/cardImg.svg';
import deleteBtn from 'icons/delete.svg';
import dropAttachment from 'icons/dropAttachment.svg';
import { ENGT_CHAT } from 'js/bot.model';
import './fileUpload.scss';

export const FileUploadTemplate = (model) => {
	const { text, description, isOldMessage } = model;

	/* html */
	const overlay = `
        <div class="preview-overlay">
            <img src="${deleteBtn}" loader="lazy"/>
            <span>Remove File</span>
        </div>`;

	/* html */
	const descriptionField = description ? `<span class="engt-msg-file-upload-description">${description}</span>` : '';

	/* html */
	const statusIndicator = `
        <div class="engt-status-indicator">
            <div class="engt-status-indicator-div"></div>
            <span data-id="engtRemoveUpload">X</span>
        </div>`;

	/* html */
	const fileDropZone = isOldMessage
		? ''
		: `<div data-id="engtFileDropZone" class="engt-msg-file-upload-box">
    <img src="${dropAttachment}" alt="drop-file" loader="lazy"/>
    <span class="drop">${ENGT_CHAT.get('GENERIC_STRINGS')?.DROP_YOUR_FILES || 'Drop your files here or'}
        <button
            tabindex="0"
            class="engt-tab-selectable button"
            aria-label="Upload attachment"
            data-id="inputTriggerBtn"
            data-interactive-field
        >
            <input type="file" data-id="inputField" name="filename" onclick="this.value = null;" style="display: none;" 
                accept="${ALLOWED_FILE_TYPES}"
                size="${ALLOWED_FILE_SIZE}" data-interactive-field>
                ${ENGT_CHAT.get('GENERIC_STRINGS')?.FILE_BROWSE || 'Browse'}
        </button>
    </span>
    <span class="max-size">${ENGT_CHAT.get('GENERIC_STRINGS')?.FILE_SIZE || 'Max file size: 5MB'}</span>
</div>`;

	/* html */
	const preview = `
        <div class="engt-msg-file-upload-preview">
            ${overlay}
            ${statusIndicator}
            <img class="preview-image" src="" onerror="this.src='${onErrorImg}'" loader="lazy"/>
            <div class="preview-file"></div>
            <div class="preview-size"></div>
        </div>`;

	// description are to be added in portal-v2, backend
	/* html */
	const html = `
        <span class="engt-msg-file-upload-title">${text}</span>
        ${descriptionField}
        ${fileDropZone}
        ${preview}
        <span class="engt-msg-file-upload-error"></span>
        <upload-btn></upload-btn>
        <skip-btn></skip-btn>
        <edit-btn></edit-btn>
    `;

	return html;
};
